import { Core } from "@faire/design-tokens";
import { useChatAuthorization } from "@faire/help-center-self-serve/chat/hooks/useChatAuthorization";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";

import { isPhoneInBusinessHours } from "../view/Phone/isPhoneInBusinessHours";
import { usePhoneAuthorization } from "../view/Phone/usePhoneAuthorization";

interface IContactUsOptionsWrapper {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  dataTestId?: string;
}

export const ContactUsOptionsWrapper: React.FC<IContactUsOptionsWrapper> = ({
  children,
  onClick,
  disabled,
  dataTestId,
}) => {
  const { hasChatAccess, chatBtnEnabled } = useChatAuthorization();
  const { hasPhoneAccess } = usePhoneAuthorization();

  const hasContactUsOptionDisabled =
    (hasChatAccess && !chatBtnEnabled) ||
    (hasPhoneAccess && !isPhoneInBusinessHours());
  return (
    <Wrapper
      onClick={onClick}
      $disabled={disabled}
      data-test-id={dataTestId}
      $hasContactUsOptionDisabled={hasContactUsOptionDisabled}
    >
      {children}
    </Wrapper>
  );
};

const Wrapper = styled(Row).attrs({
  align: "center",
  justify: { mobileAndAbove: "flex-start", tabletAndAbove: "space-between" },
})<{ $disabled?: boolean; $hasContactUsOptionDisabled?: boolean }>`
  border: 1px solid ${Core.border.muted};
  border-radius: 4px;
  padding: ${getSpacing("2x")};
  &:hover {
    border: 1px solid ${Core.border.default};
  }
  min-width: 188px;
  min-height: 122px;
  ${responsiveMediaQueries.desktopAndAbove} {
    height: ${(props) =>
      props.$hasContactUsOptionDisabled ? "142px" : "fit-content"};
    width: fit-content;
  }
  ${responsiveMediaQueries.tablet} {
    width: 100%;
  }
  ${responsiveMediaQueries.mobile} {
    width: 100%;
  }
  cursor: pointer;
  ${({ $disabled }) =>
    $disabled
      ? `pointer-events:none;
color: ${Core.text.subdued}; 
background-color: ${Core.surface.muted};`
      : ""}
`;
